/**
 * @desc sku修改并提交
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.ProductSkuRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/updateAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
